"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppVX = void 0;
const StateDashboard_1 = require("./states/StateDashboard");
const gs_1 = require("@ivanlog/gs");
const StateApp_1 = require("../plusx-lib/states/abstracts/StateApp");
const StateLoading_1 = require("./states/StateLoading");
const App_1 = require("../plusx-lib/App");
const GUIControllerBase_1 = require("../plusx-lib/controllers/GUIControllerBase");
const Web3ControllerBase_1 = require("../plusx-lib/controllers/Web3ControllerBase");
const VXInfrastructure_1 = require("../plusx-lib/contracts/VXInfrastructure");
class AppVX extends App_1.App {
    static get GUI() { return AppVX.Inst._gui; }
    static get Chain() { return AppVX.Inst._chain; }
    constructor() {
        super(AppVX.Version);
        AppVX.Inst = this;
        StateApp_1.StateApp.App = this;
        gs_1.StateGS.DefaultStateName = StateDashboard_1.StateDashboard.StateName;
    }
    startAsync() {
        const _super = Object.create(null, {
            startAsync: { get: () => super.startAsync }
        });
        return __awaiter(this, void 0, void 0, function* () {
            this._gui = new GUIControllerBase_1.GUIControllerBase(this);
            this.addInst(GUIControllerBase_1.GUIControllerBase, this._gui);
            this._chain = new Web3ControllerBase_1.Web3ControllerBase(this, AppVX.CHAIN_ID, AppVX.CHAIN_RPC);
            this.addInst(Web3ControllerBase_1.Web3ControllerBase, this._chain);
            yield _super.startAsync.call(this);
            gs_1.StateGS.RegState(StateLoading_1.StateLoading);
            gs_1.StateGS.RegState(StateDashboard_1.StateDashboard);
            yield this._gui.startAsync();
            yield gs_1.StateGS.Run(StateLoading_1.StateLoading);
            yield this._chain.startAsync();
            const vxInf = new VXInfrastructure_1.VXInfrastructure();
            let loaded = false;
            if (this._chain.isConnected)
                loaded = yield vxInf.initializeAsync();
            if (loaded) {
                this.addInst(VXInfrastructure_1.VXInfrastructure, vxInf);
                //  const byUrl = await StateGS.RunByUrl()
                //  if (byUrl === StateRunResultEnum.Failed) 
                yield gs_1.StateGS.Run(StateDashboard_1.StateDashboard);
            }
            else {
                yield gs_1.StateGS.Run(StateLoading_1.StateLoading);
            }
        });
    }
    awaitTime(timeMS) {
        return new Promise((resolve, reject) => {
            setTimeout(() => resolve(), timeMS);
        });
    }
}
exports.AppVX = AppVX;
AppVX.Version = "1.1.3";
AppVX.CHAIN_RPC = "https://rpc.pulsechain.com";
//public static CHAIN_RPC:string="https://rpc.v4.testnet.pulsechain.com"
AppVX.CHAIN_ID = 369;
//# sourceMappingURL=AppVX.js.map